import React from 'react';
import PropTypes from 'prop-types';
import {RUOLI} from "../../../../applicationConf";
import {NavBarMenuItem, SuperAdmin} from "../index";


const NavBarMenuItems = ({ruoloScelto, userCf}) => (

    <ul className="nav nav-pills mr-auto animate__animated animate__fadeIn">
        {ruoloScelto &&
        RUOLI[ruoloScelto.toUpperCase()].HEADER
            .map((header) => (<NavBarMenuItem key={Math.random().toString().slice(-11)} header={header}/>)
            )}

        {ruoloScelto &&
        RUOLI[ruoloScelto.toUpperCase()].hasOwnProperty('SUPER_ADMIN') &&
        <SuperAdmin ruoloScelto={ruoloScelto} userCf={userCf}/>}
    </ul>

);

NavBarMenuItems.propTypes = {
    ruoloScelto: PropTypes.string,
    userCf: PropTypes.string
};

export default NavBarMenuItems;

